// ./src/components/generic/ServiceIntervalTypeSelector/ServiceIntervalTypeSelector.tsx
import React, { useMemo } from "react";
import { Select, SelectProps, Text } from "@mantine/core";

import {
  ServiceIntervalType,
  SERVICE_INTERVAL_OPTIONS,
  SERVICE_INTERVAL_MAP,
} from "@/config/serviceIntervalTypes";

// ============================================
// Types
// ============================================

export interface ServiceIntervalTypeSelectorProps
  extends Omit<SelectProps, "data" | "value" | "onChange"> {
  /** Selected interval type */
  value?: ServiceIntervalType | number | null;

  /** Callback when type changes */
  onChange?: (value: ServiceIntervalType | null) => void;

  /** Show description in options */
  showDescription?: boolean;
}

// // ============================================
// // Helper functions
// // ============================================

// const getIntervalTypeDescription = (type: ServiceIntervalType): string => {
//   switch (type) {
//     case 0:
//       return "No reminders";
//     case 1:
//       return "Based on distance traveled";
//     case 2:
//       return "Based on time elapsed";
//     case 3:
//       return "Whichever comes first";
//     default:
//       return "";
//   }
// };

// ============================================
// Component
// ============================================

export const ServiceIntervalTypeSelector: React.FC<
  ServiceIntervalTypeSelectorProps
> = ({
  value,
  onChange,
  showDescription = true,
  placeholder = "Select interval type",
  label = "Interval Type",
  required = true,
  size = "md",
  ...rest
}) => {
  // Convert options to Select data format
  const options = useMemo(() => {
    return SERVICE_INTERVAL_OPTIONS.map((opt) => ({
      value: String(opt.value),
      label: opt.label,
    }));
  }, []);

  // Handle change with proper typing
  const handleChange = (newValue: string | null) => {
    if (newValue === null) {
      onChange?.(null);
    } else {
      onChange?.(Number(newValue) as ServiceIntervalType);
    }
  };

  // Render option with description
  const renderOption: SelectProps["renderOption"] = ({ option }) => {
    const intervalType = Number(option.value) as ServiceIntervalType;
    const unit = SERVICE_INTERVAL_MAP[intervalType];
    if (!unit) return option.label;

    //const description = getIntervalTypeDescription(intervalType);

    // return (
    //   <Group gap="xs" wrap="nowrap" justify="space-between" w="100%">
    //     <Text size="sm" fw={500}>
    //       {unit.label}
    //     </Text>
    //     {showDescription && description && (
    //       <Text size="xs" c="dimmed">
    //         {description}
    //       </Text>
    //     )}
    //   </Group>
    // );

    return (
      <Text size="md" fw={500}>
        {unit.label}
      </Text>
    );
  };

  // Convert value to string for Select
  const stringValue = value != null ? String(value) : null;

  return (
    <Select
      data={options}
      value={stringValue}
      onChange={handleChange}
      placeholder={placeholder}
      label={label}
      clearable={!required}
      required={required}
      renderOption={renderOption}
      allowDeselect={!required}
      size={size}
      {...rest}
    />
  );
};

export default ServiceIntervalTypeSelector;
